import { PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './save-changes-modal.html';
import { MySiteApp } from '../../my-site-app';

/**
 * @customElement
 * @polymer
 */
export class SaveChangesModal extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
    }
  
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'save-changes-modal';
    }

    _handleSaveChanges() {
        let parentComponent = document.querySelector(MySiteApp.is)
        let activeForm = parentComponent.$.mySiteSidebarWrapper.querySelector('iron-pages .iron-selected form-wrapper');
        activeForm.dispatchEvent(new CustomEvent('save-changes-modal-says-save'));
        this.toggle();
    }

    _handleDiscardChanges() {
        let parentComponent = document.querySelector(MySiteApp.is);
        let activeForm = parentComponent.$.mySiteSidebarWrapper.querySelector('iron-pages .iron-selected form-wrapper');
        activeForm.dispatchEvent(new CustomEvent('save-changes-modal-says-discard'));
        this.toggle();
    }
  
    toggle() {
        this.$.modalContainer.toggle();
    }

}

window.customElements.define(SaveChangesModal.is, SaveChangesModal);
